import { ApolloLink } from '@apollo/client';
import { IAuthToken } from '@transferz/fe-models';
import { decodeJWT } from '@transferz/fe-utils/src/jwt/decodeJWT';
import { getItem } from '@transferz/fe-utils/src/storage/getItem';
import moment from 'moment';

import { refreshToken } from './refreshToken';

function getAccessToken() {
  return getItem<IAuthToken>('authToken')?.accessToken;
}

export const authLink = new ApolloLink((operation, forward) => {
  const token = getAccessToken();
  let parsedJWT;

  if (token) {
    parsedJWT = decodeJWT(token);
  }

  if (parsedJWT && moment.unix(parsedJWT.exp).isBefore(moment())) {
    return refreshToken(operation, forward);
  }

  if (operation.operationName !== 'RefreshToken') {
    operation.setContext({
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return forward(operation);
});
